<template>
  <div class="moow-master-container play-background">
    <header-alt :overlay="true" :hideAuthButtons="true"></header-alt>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container fluid class="filter-container-hero">
      <div class="container vert-cent" >
        <b-row>
          <b-col lg="8" md="8" sm="10" cols="12">
            <md-card md-with-hover class="mt-5 island-card">
              <md-card-content style="text-align:center;">
                <b-row>
                  <b-col class="hide-when-small content-centered">
                    <div>
                      <img :src="illustration" style="max-width:200px"/>
                      <p class="moow-hero-title center mb-2">
                        {{ i18n_local.log_in_cta }}
                      </p>
                      <a href="https://moowle.com" target="_blank">{{ i18n_local.learn_more}}</a><br/>
                      <i>{{ i18n_local.landlord.user_for_free}}</i>
                    </div>
                  </b-col>
                  <b-col>
                    <p class="moow-hero-title center mb-2 mt-3">
                      {{ i18n_local.login }}
                    </p>
                    <p>
                      {{ i18n_local.need_account
                      }} <router-link to="register">{{
                        i18n_local.signup_here
                      }}</router-link>
                    </p>
                    <login-form
                      @emitSuccessfulLogin="successfulLogin"
                      @emitFailedLogin="failedLogin"
                      @emitLoading="toggleLoading"
                    ></login-form>
                  </b-col>
                </b-row>
              </md-card-content>
            </md-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import LoginForm from "./loginForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  props: {
    chatWithThisUser: {
      type: String,
    },
    initialChatMsg: {
      type: String,
    },
    regardingPropery: {
      type: String,
    },
  },
  components: {
    "login-form": LoginForm,
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    illustration() {
      return require("../../assets/moow_house.png");
    },
  },
  methods: {
    toggleLoading(value) {
      console.log("toggleLoading | value:", value)
      this.loading = value;
    },
    exitToPage(component) {
      console.log("exitToPage | component:", component)
      this.$router.push({
        path: "/" + component,
      });
    },
    redirectToChat() {
      this.$router.push({
        name: "chat",
        params: {
          chatWithThisUser: this.chatWithThisUser,
          initialChatMsg: this.initialChatMsg,
          regardingPropery: this.regardingPropery,
        },
      });
    },
    redirect() {
      let redirectComponent = this.$route.query.redirect;
      if (redirectComponent === 'chat') this.redirectToChat();
      else if (redirectComponent) this.exitToPage(redirectComponent);
      else this.exitToPage("dashboard");
    },
    successfulLogin() {
      console.log("successfulLogin")

      sessionStorage.setItem("signedIn", true);
      this.redirect();
    },
    failedLogin(error) {
      this.toggleLoading(false);
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";


</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue